// extracted by mini-css-extract-plugin
module.exports = {"sectionCopy":"contact-module--section-copy--2dSzg","imageSection":"contact-module--image-section--2zUJZ"};